<div class="modal-container" data-testid="serpro-name-confirm-modal">
  <div class="modal-header">
    <h2 data-testid="serpro-name-confirm-title">{{ 'SerproNameConfirmTitle' | translate }}</h2>
  </div>

  <div class="modal-content">
    <p class="description">
      {{ 'SerproNameConfirmDescription' | translate }}
    </p>

    <div class="diff-section">
      <div class="info-card">
        <div class="field">
          <label>{{ 'SerproNameConfirmInformedLabel' | translate }}</label>
          <div class="value" data-testid="serpro-name-confirm-current">
            {{ data.currentName || ('SerproNameConfirmNotInformed' | translate) }}
          </div>
        </div>
      </div>

      <div class="arrow-indicator">
        <mat-icon>arrow_downward</mat-icon>
      </div>

      <div class="info-card highlight">
        <div class="field">
          <label>{{ 'SerproNameConfirmOfficialLabel' | translate }}</label>
          <div class="value large" data-testid="serpro-name-confirm-serpro">{{ data.serproName }}</div>
        </div>
      </div>
    </div>

    <p class="question-text">
      <strong>{{ 'SerproNameConfirmQuestion' | translate }}</strong>
    </p>

    <div class="actions space-between">
      <button
        class="def-button outline"
        (click)="reject()"
        [disabled]="saving"
        data-testid="serpro-name-confirm-reject"
      >
        {{ 'SerproNameConfirmReject' | translate }}
      </button>
      <button
        class="def-button black"
        (click)="accept()"
        [disabled]="saving"
        data-testid="serpro-name-confirm-accept"
      >
        {{ 'SerproNameConfirmAccept' | translate }}
      </button>
    </div>
  </div>
</div>
